import { ChangeDetectionStrategy, Component, input, Input } from '@angular/core';

@Component({
    selector: 'ca-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class IconComponent {
    public icon = input.required<string>();
}
